import {
    APP_URL_CONTRACT,
    CONTRACTACTIVEBYDOCUMENT,
    DOWLOADENDOWMENT,
    DOWLOADENDOWMENTFILE,
    ENDOWMENT,
    FINGERPRINTCARD,
    FINGERPRINTENDOWMENT,
    TYPEENDOWMENT
} from '../constants';
import HttpClient from '../services/HttpClient';
const headers = {'Content-Type': 'application/json'};

export const getContractByDocument = (document, typeDocument) => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTACTIVEBYDOCUMENT}${typeDocument}/${document}`, headers).then((response) =>{
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const getEndowmentDelivery = (filters, paginator) => {
    return new Promise((resolve, reject) => {
        HttpClient.post(`${APP_URL_CONTRACT}${ENDOWMENT}criteria/?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`, filters, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error.response);
            reject(error.response);
        })
    })
}

export const createEndowmentDelivery = (body) => {
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_CONTRACT}${ENDOWMENT}`, body, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error.response);
        })
    })
}

export const createCardFormat = (id, body) => {
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_CONTRACT}${ENDOWMENT}${id}/generate-card`, body, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const cancelEndowment = (body) => {
    return new Promise((resolve) => {
        HttpClient.put(`${APP_URL_CONTRACT}${ENDOWMENT}cancel/`, body, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const getTypeEndowment = () => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_CONTRACT}${TYPEENDOWMENT}ACTIVO`, Headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const dowloadEndowment = (id) => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_CONTRACT}${DOWLOADENDOWMENT}${id}`, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

export const dowloadCard = (id) => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_CONTRACT}${DOWLOADENDOWMENTFILE}${id}`, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

// get endowment by employee
export const getEndowmentByEmployee = (id) => {
    return new Promise((resolve) => {
        HttpClient.get(`${APP_URL_CONTRACT}${ENDOWMENT}${id}/endowment-type-list`).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}

//finger print
export const fingerPrintEndowment = (body, id, typeFinger) => {
    const typeRoute = typeFinger === 'endowment' ? FINGERPRINTENDOWMENT : FINGERPRINTCARD;
    return new Promise((resolve) => {
        HttpClient.post(`${APP_URL_CONTRACT}${typeRoute}${id}`, body, headers).then((response) => {
            resolve(response);
        }).catch((error) => {
            resolve(error?.response);
        })
    })
}